var chunkMapping = {
	"0": [
		4719,
		4235
	],
	"74": [
		5128
	],
	"153": [
		5207
	],
	"154": [
		5208
	],
	"157": [
		5211
	],
	"158": [
		5212
	],
	"159": [
		5213
	],
	"160": [
		5214
	],
	"161": [
		5215
	],
	"162": [
		5216
	],
	"163": [
		5217
	],
	"164": [
		5218
	],
	"165": [
		5219
	],
	"166": [
		5220
	],
	"167": [
		5221
	],
	"168": [
		5222
	],
	"169": [
		5223
	],
	"170": [
		5224
	],
	"171": [
		5225
	],
	"172": [
		5226
	],
	"173": [
		5227
	]
};
var idToExternalAndNameMapping = {
	"4235": [
		"default",
		"./nuorder-components",
		4110
	],
	"4719": [
		"default",
		"./Containers",
		3795
	],
	"5128": [
		"default",
		"./OrderlessInvoices",
		3795
	],
	"5207": [
		"default",
		"./AsyncEventTracker",
		3795
	],
	"5208": [
		"default",
		"./HostWrapper",
		3795
	],
	"5211": [
		"default",
		"./CheckoutV3",
		3795
	],
	"5212": [
		"default",
		"./CheckoutConfirmation",
		3795
	],
	"5213": [
		"default",
		"./ContactCreditCards",
		3795
	],
	"5214": [
		"default",
		"./AuditDialog",
		3795
	],
	"5215": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3795
	],
	"5216": [
		"default",
		"./InvoiceDialog",
		3795
	],
	"5217": [
		"default",
		"./PaymentDueModal",
		3795
	],
	"5218": [
		"default",
		"./PaymentModal",
		3795
	],
	"5219": [
		"default",
		"./PaymentHistory",
		3795
	],
	"5220": [
		"default",
		"./PaymentConfigurations",
		3795
	],
	"5221": [
		"default",
		"./PaymentPreferences",
		3795
	],
	"5222": [
		"default",
		"./ManagePaymentProcessing",
		3795
	],
	"5223": [
		"default",
		"./MobilePaymentsWrapper",
		3795
	],
	"5224": [
		"default",
		"./Challenge",
		3795
	],
	"5225": [
		"default",
		"./ManagePaymentMethods",
		3795
	],
	"5226": [
		"default",
		"./LightspeedReports",
		3795
	],
	"5227": [
		"default",
		"./ShippingPromotionsListContainer",
		3795
	]
};
var idToRemoteMap = {
	"4235": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4110
		}
	],
	"4719": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5207": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5208": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5211": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5212": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5213": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5214": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5215": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5216": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5217": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5218": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5219": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5220": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5221": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5222": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5223": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5224": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5225": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5226": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5227": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}